<!--
 * @Author: Pluto 66291979@qq.com
 * @Date: 2024-05-23 17:19:24
 * @LastEditors: guojia 66291979@qq.com
 * @LastEditTime: 2024-09-06 18:36:29
 * @FilePath: /lobby/src/components/PhoneBinding.vue
 * @Description: 
 * 
 * Copyright (c) 2024 by ${git_name_email}, All Rights Reserved. 
-->
<template>
  <van-popup
    class="popup_box"
    v-model:show="showValue"
    round
    :style="{ padding: '64px' }"
    @click-overlay="onHide"
    :transition-appear="true"
  >
    <div @click="onHide" class="popup_close close_center"><span></span></div>
    <div class="popup">
      <h1 style="color: #ffddac">Phone binding</h1>
      <InputField
        v-model="phoneNumber"
        :placeholder="$t('binding.phoneNumber')"
        :validate="validate"
        style="margin-bottom: 0.2rem; font-size: 0.3rem; margin-top: 0.4rem"
        :isPhone="true"
        from="binding"
      />
      <InputField
        v-model="code"
        :placeholder="$t('binding.verificationCode')"
        style="margin-bottom: 0.2rem; font-size: 0.3rem; margin-top: 0.4rem"
        from="binding"
      />
      <div
        v-if="!isLoading"
        :class="`btn_100 ${lockBtn ? 'btn_grey' : 'btn_yellow'}`"
        @click="onSend"
      >
        {{ btnName == '' ? $t('binding.send') : btnName }}
      </div>
      <div
        v-else
        class="btn_100 btn_yellow"
        style="
          display: flex;
          justify-content: center;
          align-items: center;
          padding: 0.1rem 0 0.1rem 0;
        "
      >
        <img :src="`${resBaseUrl}loading.gif`" width="28" height="28" />
      </div>
      <div class="popup_footer" @click="onChat">{{ $t('register.service') }}</div>
    </div>
  </van-popup>
</template>

<script>
import InputField from '@/components/InputField.vue'
import { config } from '@/common/config'
import { mapActions, mapState } from 'pinia'
import { useUserStore } from '@/stores/user'
import { BUS, POPUP } from '@/event/EventCenter'
import { showSuccessToast } from 'vant'
export default {
  name: 'DhPhoneBinding',
  components: {
    InputField
  },
  props: {
    username: {
      type: String,
      default: ''
    },
    validate: {
      type: Function,
      default: () => ''
    },
    show: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      showValue: false,
      phoneNumber: '',
      code: '',
      isLoading: false,
      resBaseUrl: config.resBaseUrl,
      btnName: '',
      timer: null,
      cd: 60,
      lockBtn: true,
      step: 1
    }
  },
  watch: {
    phoneNumber(newValue) {
      if (this.validate(newValue) <= 0) {
        this.setBtnName(2)
      }
    },
    code(newValue) {
      if (newValue.length >= 6 && this.validate(this.phoneNumber) <= 0) {
        this.setBtnName(4)
      }
    },
    show(newValue) {
      if (this.showValue == newValue) {
        return
      }
      this.showValue = newValue
    }
  },
  computed: {
    ...mapState(useUserStore, ['country', 'isLogin', 'balance'])
  },
  mounted() {
    this.showValue = this.show
  },
  methods: {
    ...mapActions(useUserStore, { sms: 'sms', bindPhone: 'bindPhone' }),
    onHide() {
      this.$bus.$emit(BUS.SHOW_POPUP, { from: 'binding', to: POPUP.BINDING_PHONE, show: false })
    },
    onSend() {
      if (this.isLogin) {
        if (this.step == 2) {
          if (this.phoneNumber == '' || this.validate(this.phoneNumber) > 0) {
            this.$bus.$emit(BUS.CHECK_INPUT_VALUE, 'binding')
            return
          }
          this.isLoading = true
          this.setBtnName(3)
          this.sms(this.country, this.phoneNumber).finally(() => {
            this.isLoading = false
          })
        } else if (this.step == 4) {
          if (this.phoneNumber == '' || this.validate(this.phoneNumber) > 0) {
            this.$bus.$emit(BUS.CHECK_INPUT_VALUE, 'binding')
            return
          }
          if (this.code == '' || this.code.length < 6) {
            return
          }
          this.isLoading = true
          this.setBtnName(5)
          this.bindPhone(this.phoneNumber, this.code)
            .then(() => {
              this.code = ''
              this.phoneNumber = ''
              this.setBtnName()
            })
            .finally(() => {
              this.isLoading = false
              showSuccessToast({
                message: this.$t('binding.success'),
                wordBreak: 'break-word',
                onClose: () => {
                  this.$bus.$emit(BUS.SHOW_POPUP, {
                    from: 'binding',
                    to: POPUP.BINDING_PHONE,
                    show: false
                  })
                },
                duration: 3000
              })
            })
        }
      }
    },
    setBtnName(status = 1) {
      this.timer && clearInterval(this.timer)
      this.step = status
      // 锁按钮 发送验证码
      // 解锁按钮 发送验证码
      // 锁按钮 验证码倒计时
      // 解锁按钮 确认绑定
      // 锁定  确认绑定
      switch (this.step) {
        case 1:
          this.btnName = this.$t('binding.send')
          this.lockBtn = true
          break
        case 2:
          this.btnName = this.$t('binding.send')
          this.lockBtn = false
          break
        case 3:
          this.lockBtn = true
          this.cd = 60
          this.btnName = this.$t('binding.verification', { cd: this.cd })
          this.timer = setInterval(() => {
            this.cd--
            this.btnName = this.$t('binding.verification', { cd: Math.max(this.cd, 0) })
            if (this.cd < 0) {
              clearInterval(this.timer)
              this.setBtnName(2)
            }
          }, 1000)
          break
        case 4:
          this.btnName = this.$t('binding.confirm')
          this.lockBtn = false
          break
        case 5:
          this.btnName = this.$t('binding.confirm')
          this.lockBtn = true
          break
        default:
          break
      }
    },
    onChat() {
      this.$bus.$emit(BUS.SHOW_CHAT)
    }
  }
}
</script>

<style lang="scss" scoped>
.popup_box {
  width: 6.5rem;
  height: auto;
  margin: 0 auto;
  padding: 0 !important;
  overflow: visible !important;
  border: solid 0.04rem transparent;
  border-radius: 0.16rem;
  background-color: #000;
  background-image: linear-gradient(#000, #000),
    linear-gradient(130deg, #dfc572 0%, #916c38 50%, #825c2d 50.1%, #aa884a 100%);
  background-origin: border-box;
  background-clip: content-box, border-box;
  text-align: center;
  // overflow: hidden;

  .close_center {
    display: flex !important;
    margin-top: -0.5rem !important;
    justify-content: center;
    align-items: flex-start;
  }

  .popup_close {
    height: 0.8rem;
    width: 0.8rem;
    border-radius: 50%;
    background-color: #000;
    border: solid 4px transparent;
    background-image: linear-gradient(#000, #000),
      linear-gradient(130deg, #dfc572 0%, #916c38 50%, #825c2d 50.1%, #aa884a 100%);
    background-origin: border-box;
    background-clip: content-box, border-box;
    margin-top: -1.2rem;
    text-align: center;
    position: absolute;
    display: block;
    z-index: 2;
    margin-left: 90%;

    span {
      display: inline-block;
      width: 0.6rem;
      height: 0.08rem;
      background-color: #aa884a;
      background-image: linear-gradient(
        130deg,
        #dfc572 0%,
        #916c38 50%,
        #825c2d 50.1%,
        #aa884a 100%
      );
      transform: rotate(45deg);
      margin-top: 0.355rem;
    }

    span::after {
      content: '';
      display: block;
      width: 0.6rem;
      height: 0.08rem;
      background-color: #aa884a;
      background-image: linear-gradient(
        130deg,
        #dfc572 0%,
        #916c38 50%,
        #825c2d 50.1%,
        #aa884a 100%
      );
      transform: rotate(-90deg);
    }
  }

  .popup {
    width: 90%;
    height: auto;
    border-radius: 12px;
    display: block;
    padding: 5% 5% 5% 5%;
    margin: 0 auto;

    h1 {
      font-size: 0.3rem;
      line-height: 0.4rem;
      margin: 0.1rem 0;
      font-weight: normal;
    }

    h2 {
      font-size: 0.24rem;
      line-height: 0.3rem;
      margin: 0.1rem 0;
      font-weight: normal;
    }

    p {
      line-height: 0.32rem;
      margin: 0;
      color: #fff;
    }

    .btn_100 {
      line-height: 0.66rem;
      text-align: center;
      border-radius: 0.33rem;
      margin: 0.4rem 0;
      font-size: 0.3rem;
    }

    .btn_yellow {
      color: #fff;
      background-color: #aa884a;
      border: 2px solid #aa884a;
    }

    .btn_grey {
      color: #737373;
      background-color: #4d4d4d;
      border: 2px solid #4d4d4d;
    }

    .popup_footer {
      text-align: center;
      margin: 0px;
      padding: 0.3rem 0;
      height: auto;
      width: 100%;
      color: #ffddac;
      font-size: 0.38rem;

      overflow: hidden;
      text-decoration: underline;
    }
  }
}
</style>
